<!--
 * @Description: 分组管理
 * @Author: gao shuai
 * @Date: 2020-07-03 09:20:00
 * @LastEditTime: 2020-07-07 17:35:17
 * @LastEditors: gao shuai
-->
<template>
  <div class="groupMange">
    <van-pull-refresh class="scrolldiv" v-model="refreshing" @refresh="onRefresh">
      <van-list v-model="loading" :offset="80" :immediate-check="false" :finished="finished" finished-text="我是有底线的" @load="onLoad">
        <ul class="listbox">
          <li v-for="(item,i) in list" :key="'list'+i">
            <van-swipe-cell>
              <div class="divbox">
                <p>
                  <span class="tit">创建时间：</span>
                  <span class="txt">{{item.createDate}}</span>
                </p>
                <p>
                  <span class="tit">分组名称：</span>
                  <span class="txt">{{item.name}}</span>
                </p>
                <p>
                  <span class="tit">分区个数：</span>
                  <span class="txt">{{item.partitionIdCount}}</span>
                </p>
              </div>
              <template #right>
                <van-button square type="primary" text="编辑" class="cell_button" @click="editgroup(item.name,item.id)" />
                <van-button square type="danger" text="删除" class="cell_button" @click="deletegroup(item.id)" />
              </template>
            </van-swipe-cell>
          </li>
        </ul>
      </van-list>
    </van-pull-refresh>
    <!-- 编辑的弹框 -->
    <van-dialog v-model="dialog.show" title="编辑游戏分组" @close="dialoginit" @confirm="editSure" show-cancel-button show-confirm-button>
      <ul class="operBox">
        <li>
          <span class="tit">分组名称：</span>
          <div class="input">
            <span class="inp">
              <input v-model="dialog.groupName">
            </span>
          </div>
        </li>
      </ul>
    </van-dialog>
    <!-- 增加分组弹框 -->
    <van-dialog v-model="dialog1.show" title="添加游戏分组" @close="dialoginit1" @confirm="editSure1" show-cancel-button show-confirm-button>
      <ul class="operBox">
        <li>
          <span class="tit">分组名称：</span>
          <div class="input">
            <span class="inp">
              <input v-model="dialog1.groupName">
            </span>
          </div>
        </li>
      </ul>
    </van-dialog>
    <float-block @click="dialog1.show=true"></float-block>
  </div>
</template>

<script>
import floatBlock from '../components/floatBlock';
export default {
  components: {
    floatBlock
  },
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      PageNumber: 1,
      PageSize: 15,
      total: 0,
      dialog: {
        show: false,
        groupName: '',
        id: ''
      },
      dialog1: {
        show: false,
        groupName: ''
      }
    };
  },
  methods: {
    getlist() {
      this.$api.home
        .teamlist({
          PageNumber: this.PageNumber,
          PageSize: this.PageSize
        })
        .then((data) => {
          if (data.status === 200) {
            if (this.PageNumber === 1) {
              this.list = data.data;
            } else {
              this.list = this.list.concat(data.data);
            }
            this.total = JSON.parse(data.headers['x-pagination']).TotalCount;
            if (this.list.length >= this.total) {
              this.finished = true;
            } else {
              this.finished = false;
              this.loading = false;
              this.PageNumber++;
            }
            this.refreshing = false;
          } else {
            this.list = [];
            this.refreshing = false;
            this.finished = false;
            this.loading = false;
          }
        })
        .catch((err) => {
          this.refreshing = false;
          this.finished = false;
          this.loading = false;
          this.$toast(err.message);
        });
    },
    // 下拉刷新
    onRefresh() {
      this.PageNumber = 1;
      this.finished = false;
      this.loading = false;
      this.getlist();
    },
    // 上拉加载
    onLoad() {
      if (this.finished || this.refreshing) {
        this.loading = false;
        return;
      }
      this.getlist();
    },
    // 编辑分组确认
    editSure() {
      if (this.dialog.groupName === '') {
        this.$toast.fail('请输入分组名称！');
        return;
      }
      this.$api.home
        .editteam({
          id: this.dialog.id,
          name: this.dialog.groupName
        })
        .then((data) => {
          if (data.status === 200) {
            this.$toast.success('编辑成功！');
            this.PageNumber = 1;
            this.finished = false;
            this.dialog.show = false;
            this.getlist();
          }
        })
        .catch((err) => {
          this.$toast.fail(err.message);
        });
    },
    // 编辑分组
    editgroup(name, id) {
      this.dialog.groupName = name;
      this.dialog.id = id;
      this.dialog.show = true;
    },
    // 弹框初始化
    dialoginit() {
      this.dialog.groupName = '';
      this.dialog.id = '';
    },
    // 删除分组
    deleteTeam(id) {
      this.$api.home
        .deleteteam({
          groupId: id
        })
        .then((data) => {
          if (data.status === 200) {
            this.$toast.success('删除成功！');
            this.PageNumber = 1;
            this.finished = false;
            this.getlist();
          }
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    // 删除分组提示
    deletegroup(id) {
      this.$dialog
        .confirm({
          message: '删除后数据无法恢复，是否确定？'
        })
        .then(() => {
          this.deleteTeam(id);
        })
        .catch(() => {
          // on cancel
        });
    },
    // 添加分组
    editSure1() {
      if (this.dialog1.groupName === '') {
        this.$toast('请输入分组名称');
        return;
      }
      this.$api.home
        .addteam({
          name: this.dialog1.groupName
        })
        .then((data) => {
          if (data.status === 200) {
            this.$toast.success('添加成功');
            this.PageNumber = 1;
            this.list = [];
            this.getlist();
            this.dialog1.show = false;
          }
        })
        .catch((err) => {
          this.$toast(err.message);
        });
    },
    // 添加分组弹框初始化
    dialoginit1() {
      this.dialog1.groupName = '';
    }
  },
  created() {
    this.getlist();
  }
};
</script>

<style lang="scss" scoped>
.groupMange {
  height: 100%;
  overflow: hidden;
  .scrolldiv {
    height: 100%;
    overflow-y: auto;
  }
  .listbox {
    li {
      border-bottom: 3px solid #ededed;
      .divbox {
        background: #fff;
        padding: 10px 20px 6px;
        color: #707070;
        p {
          margin-bottom: 3px;
          .tit {
            font-size: 13px;
          }
          .txt {
            font-size: 10px;
          }
        }
      }
      .cell_button {
        height: 100%;
      }
    }
  }
  .operBox {
    padding-top: 20px;
    li {
      margin-bottom: 23px;
      text-align: center;
      .tit {
        display: inline-block;
        vertical-align: middle;
        font-size: 14px;
        color: #666;
      }
      .input {
        display: inline-block;
        vertical-align: middle;
        width: 180px;
        .inp {
          display: block;
          margin-right: 10px;
          background: #fff;
          border-radius: 4px;
          color: #b1b1b1;
          font-size: 14px;
          input {
            display: block;
            border: none;
            outline: none;
            width: 100px;
            height: 30px;
            padding: 0 10px;
            width: 100%;
            border-radius: 4px;
            border: 1px solid #dbd8d8;
            &:focus {
              border-color: #1abc9c;
            }
          }
        }
      }
    }
  }
}
</style>
